export default __webpack_public_path__ + "static/media/triangle_2.6bc07f6e.svg";